import React from "react";
import "./Chelia.scss";
import data from "../Chelia/data.json";
import Card from "../../Component/Card Chelia/cardchelia";
import Chelia5images from "../../media/Chelia/Chelia5";
import Chelia5Atticimages from "../../media/Chelia/Chelia5Attic";
import Chelia6images from "../../media/Chelia/Chelia6";
import Chelia6Atticimages from "../../media/Chelia/Chelia6Attic";

const imageMap = {
  Chelia5images,
  Chelia5Atticimages,
  Chelia6images,
  Chelia6Atticimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="chelia" className="produk">
      <div className="cardhome-containerviola">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
